import React from "react";
import { ListInstitutionalDocuments } from "../../../components/Student/InstitutionalDocuments";
import "./InstitutionalDocuments.scss";

const CURRENT_YEAR = new Date().getFullYear().toString();

export function InstitutionalDocuments() {
  return (
    <div className="student-institutional-documents">
      <h2 className="student-institutional-documents__title">
        Documentos Institucionales
      </h2>
      <p className="student-institutional-documents__description">
        Consulta y descarga los documentos institucionales publicados por el
        colegio (Carta Informativa, Plan Anual de Trabajo, PEI, Reglamento
        Interno, entre otros).
      </p>
      <ListInstitutionalDocuments year={CURRENT_YEAR} />
    </div>
  );
}
